module.exports = __webpack_public_path__ + "img/ExitusC_logo.aa51abb1.png";